import { ChainId } from '@nominex/nomiswap-sdk'
import BigNumber from 'bignumber.js'
import { DEFAULT_TOKEN_DECIMAL } from 'config'
import { BIG_TEN } from 'config/constants/bigNumber'
import { getPoolsConfig } from 'config/pools'
import { getFarmingHelperContract } from 'utils/contractHelpers'

export const fetchPoolsAllocation = async (chainId: ChainId) => {
  const poolsConfig = getPoolsConfig(chainId)
  const poolsCalls = poolsConfig.map(async ({ launchpoolAddress }) =>
    getFarmingHelperContract(chainId).currentSupplyRate(launchpoolAddress),
  )

  const poolsAllocation = await Promise.all(poolsCalls)

  return poolsConfig.map(({ sousId }, index) => ({
    tokensPerSec: new BigNumber(poolsAllocation[index].toString()).div(BIG_TEN.pow(DEFAULT_TOKEN_DECIMAL)),
    sousId,
  }))
}
